/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Cta_Request_DemoInputs */

const en_landing_cta_request_demo = /** @type {(inputs: Landing_Cta_Request_DemoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request a demo`)
};

/**
* | output |
* | --- |
* | "Request a demo" |
*
* @param {Landing_Cta_Request_DemoInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_cta_request_demo = /** @type {((inputs?: Landing_Cta_Request_DemoInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Cta_Request_DemoInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_cta_request_demo(inputs)
});